<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="{{datosAlertado.icono}}" id="ico"></i>
		<h1 style="display:inline-block;" *ngIf="datosAlertado.producto == 2">{{datosAlertado.titulo}}</h1>
		<h1 style="display:inline-block;" *ngIf="datosAlertado.producto == 9"> Alerta Botón Ciudadano </h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"></h1>
		</div>
		<div class="mt-3">
			<kt-boton-exportar-tabla [tipoBoton]="'grid'" [nombreArchivo]="datosAlertado.titulo" [datos]="datosReporte"
				[buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid" *ngIf="datosAlertado.producto == 2">
						<dx-data-grid id="gridContainer" [rowAlternationEnabled]="true" [columnHidingEnabled]="true"
							[showBorders]=" true" [dataSource]="datosAlertado.datos">
							<dxo-paging [pageSize]="10"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
							<dxi-column caption="Acciones" cellTemplate="Abrir" [width]="120">
							</dxi-column>
							<dxi-column dataField="descripcion" caption="Vehiculo" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="placas" caption="Placa" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
								<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
									(click)="ubicarVehiculo(d.data)">
									<i class="fas fa-eye"></i>
								</dx-button>
							</div>
						</dx-data-grid>
					</div>

					<div class="data-grid" *ngIf="datosAlertado.producto == 9">
						<dx-data-grid id="gridContainer" [rowAlternationEnabled]="true" [columnHidingEnabled]="true"
							[showBorders]=" true" [dataSource]="datosAlertado.datos">
							<dxo-paging [pageSize]="10"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
							<dxi-column caption="Acciones" alignment="center" cellTemplate="Abrir" [width]="120">
							</dxi-column>
							<dxi-column dataField="descripcionAlarma" caption="Evento" cellTemplate="color" alignment="center" [width]="220">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
								<div *dxTemplate="let p of 'color'" style="align-items: center;">
									<p *ngIf="p.data.descripcionAlarma === 'Lid Restored'" class="gris">Tapa Restaurada</p>
									<p *ngIf="p.data.descripcionAlarma === 'Lid Opened'" class="gris">Tapa Abierta</p>
									<p *ngIf="p.data.descripcionAlarma === 'Audible Panic Alarm'" class="rojo">Alarma de Pánico</p>
									<p *ngIf="p.data.descripcionAlarma === 'Alarm Silenced'" class="azul">Alarma Silenciada</p>
									<p *ngIf="p.data.descripcionAlarma === 'Device Restored'" class="gris">Dispositivo Restaurado</p>
									<p *ngIf="p.data.descripcionAlarma === 'IP Address Already Used'" class="gris">Dirección IP Utilizada</p>
									<p *ngIf="p.data.descripcionAlarma === 'Normal IP address'" class="gris">Dirección IP Normal</p>
									<p *ngIf="p.data.descripcionAlarma === 'Armed'" class="verde">Armado</p>
									<p *ngIf="p.data.descripcionAlarma === 'Disarmed'" class="amarillo">Desarmado</p>

									<p *ngIf="p.data.descripcionAlarma === 'Expander AC Power Loss'" class="gris">Pérdida de Alimentación</p>
									<p *ngIf="p.data.descripcionAlarma === '24H Alarm'" class="rojo">Alarma Sensor de Movimiento</p>
									<p *ngIf="p.data.descripcionAlarma === 'Network Fault'" class="gris">Fallo de Red</p>
									<p *ngIf="p.data.descripcionAlarma === 'Device Offline'" class="gris">Dispositivo Sin Conexión</p>

									<p *ngIf="p.data.descripcionAlarma === 'Cellular Fault'" class="gris">Fallo de Celular</p>
									<p *ngIf="p.data.descripcionAlarma === 'Cellular Restored'" class="gris">Celular Resturado</p>
									<p *ngIf="p.data.descripcionAlarma === 'Mains Power Lost'" class="gris">Perdida de Alimentación de Red</p>
									<p *ngIf="p.data.descripcionAlarma === 'Jamming Detected'" class="gris">Interferencia Detectada</p>
									<p *ngIf="p.data.descripcionAlarma === 'Jamming Restored'" class="gris">Interferencia Restaurada</p>
									<p *ngIf="p.data.descripcionAlarma === 'Device Enrolled'" class="gris">Dispositivo Inscrito</p>
									<p *ngIf="p.data.descripcionAlarma === 'Device Deleted'" class="gris">Dispositivo Eliminado</p>

									<p *ngIf="p.data.descripcionAlarma === 'Mains Power Restored'" class="gris">Red Eléctrica Restaurada</p>
									<p *ngIf="p.data.descripcionAlarma === 'Network Restored'" class="gris">Red Restaurada</p>
								</div>
							</dxi-column>
							<dxi-column dataField="nombre" caption="Nombre" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="modelo" caption="Modelo" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="numeroSerie" caption="Número Serie" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
								<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
									(click)="ubicarPanel(d.data)">
									<i class="fas fa-eye"></i>
								</dx-button>
								<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
									(click)="silenciarAlarma(d.data)">
									<i class="fas fa-volume-slash"></i>
								</dx-button>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>